export const COLUMNS = [
    {
        Header: "Propostas",
        accessor: "numeroProposta",
    },
    {
        Header: "Data de digitação",
        accessor: "dataEntradaProposta",
    },
]


